module.exports = __webpack_public_path__ + "img/etc-etc-new-arrow-l.80c3667e.svg";